import { PrimaryButton, GoldButton } from "@/components/Layout";
import { B } from "@/components/BrandText";
import { usePageTitle } from "@/hooks/usePageTitle";

export default function About() {
  usePageTitle(
    "About | One More Shift",
    "One More Shift is being built in the communities south and southeast of Houston to connect people who know with people who need to know. Experience shouldn't disappear."
  );

  return (
    <div className="max-w-4xl mx-auto px-6 py-20" data-testid="about-page">
      <h1 className="text-4xl md:text-5xl font-bold" data-testid="about-headline">
        Experience shouldn't disappear.
      </h1>
      <p
        className="mt-6 inline-block bg-card border-l-4 border-secondary px-5 py-3 text-lg font-semibold text-primary"
        data-testid="about-founding-note"
      >
        Now building our founding local advisor network.
      </p>

      <div className="mt-10 space-y-6 text-lg leading-relaxed text-foreground">
        <p>
          Every year, experienced people leave full-time careers carrying decades of practical knowledge with them.
          Knowledge about how things actually work — how to run a floor, train a driver, calm a customer, fix a
          process, or teach a skill that never made it into a manual.
        </p>
        <p>
          At the same time, businesses and individuals encounter problems where experienced guidance could be
          enormously useful — but hiring another full-time employee doesn't make sense.
        </p>
        <p className="font-semibold text-primary"><B /> is being built to bridge that gap.</p>
      </div>

      <div className="mt-12 bg-card border-l-4 border-secondary rounded-md p-8" data-testid="about-idea-callout">
        <p className="text-2xl md:text-3xl font-serif font-bold text-primary">
          "Connect people who know with people who need to know."
        </p>
      </div>

      <div className="mt-12 space-y-6 text-lg leading-relaxed text-foreground">
        <h2 className="text-2xl md:text-3xl font-semibold text-primary">Our mission</h2>
        <p className="text-xl font-semibold text-accent" data-testid="about-mission">
          To give valuable experience another opportunity to make an impact.
        </p>
        <p>
          <B /> is starting local in the communities south and southeast of Houston — initially serving
          Pearland, Friendswood, Alvin, League City, Webster, Dickinson and the Clear Lake area. We're intentionally
          starting with a small group of nearby communities so we can personally build and test the network. We are
          currently building our founding local advisor network — experienced people interested in occasional
          consulting, mentoring, training, troubleshooting and project work — and hearing from businesses and
          individuals about the problems they'd like experienced help with.
        </p>
        <p>
          A note on qualifications: certain services may require licenses, certifications, background checks or other
          qualifications, and availability will depend on the engagement. <B /> does not provide medical,
          psychological or professional child-development advice.
        </p>
      </div>

      <div className="mt-14 flex flex-col sm:flex-row gap-4">
        <PrimaryButton to="/find-experience" testId="about-need-experience-button">
          FIND AN ADVISOR
        </PrimaryButton>
        <GoldButton to="/share-experience" testId="about-have-experience-button">
          BECOME AN ADVISOR
        </GoldButton>
      </div>
    </div>
  );
}
